module.exports = __webpack_public_path__ + "static/media/image014.2ee64728.jpg";